import React from 'react';

interface CalendarHeaderProps {
  year: number;
  month: number;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  onToday: () => void;
  /** 移动端：增大触摸目标至 44px */
  isMobile?: boolean;
  /** 移动端：返回书签回调，传入时在左侧显示返回按钮 */
  onBack?: () => void;
}

const monthNames = [
  '一月', '二月', '三月', '四月', '五月', '六月',
  '七月', '八月', '九月', '十月', '十一月', '十二月',
];

const touchTargetClass = 'min-h-[44px] min-w-[44px] touch-manipulation';

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  year,
  month,
  onPreviousMonth,
  onNextMonth,
  onToday,
  isMobile = false,
  onBack,
}) => {
  const btnClass = `rounded-xl hover:bg-primary/10 transition-colors duration-200 cursor-pointer ${isMobile ? `p-2 ${touchTargetClass}` : 'p-2'}`;
  return (
    <div className="flex items-center justify-between mb-2 flex-shrink-0">
      <div className="flex items-center gap-1">
        {onBack && (
          <button
            onClick={onBack}
            className={btnClass}
            title="返回书签"
            aria-label="返回书签"
          >
            <svg className="w-5 h-5 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <button
          onClick={onPreviousMonth}
          className={btnClass}
        >
        <svg className="w-5 h-5 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      </div>
      
      <div className="flex items-center gap-2">
        <h2 className="text-xl font-semibold text-foreground">
          {year}年{monthNames[month]}
        </h2>
        <button
          onClick={onToday}
          className={`px-3 py-1 text-sm text-muted-foreground hover:text-foreground hover:bg-primary/10 rounded-xl transition-colors duration-200 cursor-pointer ${isMobile ? touchTargetClass : ''}`}
        >
          今天
        </button>
      </div>
      
      <button
        onClick={onNextMonth}
        className={btnClass}
      >
        <svg className="w-5 h-5 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};
